export const WRITE_PERMISSION = 'write'
export const NONE_PERMISSION = 'none'
export const MARKETPLACE_ALL_KEY = 'marketplace.all'

export const PERMISSION_KEYS = {
  AI_FEATURES: 'ai_features',
  COMPETITIVE_INTELLIGENCE: 'competitive_intelligence',
  EXTENSION: 'extension',
  FBA_REIMBURSEMENT: 'fba_reimbursement',
  FIND_PRODUCTS: 'find_products',
  PRODUCTS: 'products',
  KEYWORDS: 'keywords',
  SUPPLIERS: 'suppliers',
  ACADEMY: 'academy',
  SALES_ANALYTICS: 'sales_analytics',
  ADVERTISING: 'advertising',
  LAUNCH: 'launch',
  INVENTORY: 'inventory',
  MY_PRODUCTS: 'my_products',
  PUBLIC_API: 'public_api',
  TOOLBOX: 'toolbox'
}

export const SET_FEATURE_LIMIT_EVENT = 'set-feature-limit'

export const FEATURE_LIMIT_MAX_HEADER = 'JS-Feature-Limit-Maximum'
export const FEATURE_LIMIT_COUNT_HEADER = 'JS-Feature-Limit-Count'
export const GATED_FEATURE_ERROR_TYPE = 'Gated Feature'

export const NO_ACCESS_ROUTES = [
  'sales-estimator',
  'listing-grader',
  'review-analysis',
  'database',
  'tracker',
  'opportunity-finder',
  'category-trends',
  'supplier',
  'keyword',
  'launch',
  'sales-analytics',
  'advertising',
  'inventory-forecast',
  'product-costs-and-settings',
  'academy'
]
